import { render, staticRenderFns } from "./preloader.vue?vue&type=template&id=297e2b72&scoped=true&"
var script = {}
import style0 from "./preloader.vue?vue&type=style&index=0&id=297e2b72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297e2b72",
  null
  
)

export default component.exports